const styles = (theme) => ({
  // estilos do modal de histórico de ping
  pingModalDialog: {
    borderRadius: "16px",
    overflow: "hidden",
  },
  pingModalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px 8px",
    gap: 1,
  },
  pingModalHeaderIcon: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  pingModalTitle: {
    fontWeight: 600,
    fontSize: "1.1rem",
  },
  pingModalContent: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: "8px 20px 20px",
  },
  graphPaper: {
    p: 0,
    overflow: "hidden",
    borderRadius: 4,
  },
});

export default styles;
